import { graphqlURI } from "../../../config";

const env = process.env.RUN_ENV;
export const GRAPHQL_URI = graphqlURI[env];
